<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-h4 v-bind='{...{},...{}}' :style='"font-size:22px"' class="col text-center py-5" >
                <template #default>ممنون از اینکه تجربه خریدتان را با نودانو به اشتراک گذاشتید ❤️   </template>
                </m-h4></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH4 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
